var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirplaneTilt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3672 6.28127L13.7422 8.75002L16.2422 15.625L14.3672 17.5L10.6328 12.0313L8.74219 13.75V15.625L6.86719 17.5L5.75781 14.2266L2.49219 13.125L4.36719 11.25H6.24219L8.11719 9.37502L2.49219 5.62502L4.36719 3.75002L11.2422 6.25002L13.7188 3.63283L13.6641 3.67189C14.0163 3.31965 14.494 3.12177 14.9922 3.12177C15.4903 3.12177 15.9681 3.31965 16.3203 3.67189C16.6726 4.02413 16.8704 4.50187 16.8704 5.00002C16.8704 5.49816 16.6726 5.9759 16.3203 6.32814L16.3672 6.28127Z",
    stroke: "url(#paint0_linear_5900_20255)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5900_20255",
    x1: 13.8205,
    y1: 16.4108,
    x2: 4.56179,
    y2: 3.12177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneTilt);
export default __webpack_public_path__ + "static/media/airplaneTilt.dbc08e01f4fc83312d6d129cbb4c54e7.svg";
export { ForwardRef as ReactComponent };